'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const buildAttrs = require('./utils/build-attrs.js');
const createRenderState = require('./utils/create-render-state.js');
const scrapeMotionValues = require('./utils/scrape-motion-values.js');
const visualElement = require('./visual-element.js');
const useVisualState = require('../../motion/utils/use-visual-state.js');

var svgMotionConfig = {
  createVisualElement: function (_, options) {
    return visualElement.svgVisualElement(options, {
      enableHardwareAcceleration: false
    });
  },
  useVisualState: useVisualState.makeUseVisualState({
    scrapeMotionValuesFromProps: scrapeMotionValues.scrapeMotionValuesFromProps,
    createRenderState: createRenderState.createSvgRenderState,
    onMount: function (props, instance, _a) {
      var renderState = _a.renderState,
        latestValues = _a.latestValues;
      try {
        renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
      } catch (e) {
        // Most likely trying to measure an unrendered element under Firefox
        renderState.dimensions = {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        };
      }
      if (isPath(instance)) {
        renderState.totalPathLength = instance.getTotalLength();
      }
      buildAttrs.buildSVGAttrs(renderState, latestValues, undefined, undefined, {
        enableHardwareAcceleration: false
      }, props.transformTemplate);
      visualElement.renderSVG(instance, renderState);
    }
  })
};
function isPath(element) {
  return element.tagName === "path";
}

exports.svgMotionConfig = svgMotionConfig;
